import React, { Component, useState, useEffect } from "react";
import styled from "styled-components";
import { Ptag } from ".";
import { useNavigate } from "react-router-dom";
import logout from "../../assets/images/logout.png";
import { theme } from "theme";

const HeaderDasNew = (props) => {
  let navigate = useNavigate();

  const redirect_managerdashboard = () => {
    localStorage.clear();
    window.history.go(-window.history.length);
    navigate("/");
  };

  return (
    <HomeWrapper>
      <MainDiv>
        <WelcomeLeft>
          <Ptag
            fontSize="32px"
            fontFamily="Merriweather"
            fontWeight="600"
            letterSpacing="0.6px"
            // color={theme.accentColor}
            letterHeight="1.13"
            marginBottom="1rem"
          >
            {props && props.company_name}
          </Ptag>
          {/* <Ptag marginTop="14px" fontSize="14px">
            Welcome to Neo Insurance Broking
          </Ptag> */}
        </WelcomeLeft>
        <Mainbuttonwrapper>
          {/* <RewardsRight onClick={redirect_managerdashboard}>
                        <img style={{'marginRight' :'6px'}} src={logout} width="30px" height="24px" /> 
                        <Ptag fontSize='14px' fontWeight='600' color='#436AB2' background="" letterHeight='normal' textTransform=''>
                            Log out 
                        </Ptag>
                    </RewardsRight> */}
        </Mainbuttonwrapper>
      </MainDiv>
    </HomeWrapper>
  );
};

export default HeaderDasNew;

const HomeWrapper = styled.div`
  margin-left: 248px;
  transition: margin-left 0.2s ease-in;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: #dadada;
  padding-bottom: 12px;
`;

const MainDiv = styled.div`
  display: flex;
  text-align: left;
  background-color: white;
  padding: 40px 40px 18px 40px;
  line-height: 1.5;
  letter-spacing: 0.5px;
  color: #436ab2;
  justify-content: space-between;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
  align-items: center;
`;

const WelcomeLeft = styled.div`
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  color: #436ab2;
`;
const Mainbuttonwrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const RewardsRight = styled.div`
  display: flex;

  cursor: pointer;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: 0.6px;
  color: #436ab2;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 12px 16px;

  box-shadow: rgb(0 0 0 / 15%) 0px 1px 4px 0px;
  border-radius: 5px;
  border: none;
`;
